module.exports = __webpack_public_path__ + "static/media/pf_item_27.b59c95ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_27.jpg
// module id = 194
// module chunks = 0